import { Alchemy, Network } from "alchemy-sdk"

let alchemyClientInstance: Alchemy | null = null
const getAlchemyClient = () => {
  if (!alchemyClientInstance) {
    const config = {
      apiKey: process.env.NEXT_PUBLIC_ALCHEMY_ETH_API_KEY,
      network: Network.ETH_MAINNET,
    }
    alchemyClientInstance = new Alchemy(config)
  }

  return alchemyClientInstance
}

export const getAddressFromEns = async (ens: string) => {
  const address = await getAlchemyClient().core.resolveName(ens)

  return address
}
